import { IS_MATOMO_DATA_LAYER, IS_GOOGLE_DATA_LAYER } from "../constants/tracking"
import getMomentDateObj from "../functions/getMomentDateObj"

const trackingTimezone = "Europe/Berlin"

// general
const track = (eventCategory, eventAction, eventOrigin, addData) => {
    if(IS_MATOMO_DATA_LAYER) {
        window._mtm.push({
            event: eventAction,
            event_category: eventCategory,
            event_origin: eventOrigin,
            ... addData
        })
    } else if(IS_GOOGLE_DATA_LAYER) {
        dataLayer.push({
            event: eventAction,
            event_category: eventCategory,
            event_origin: eventOrigin,
            ... addData
        })
    } else {
        console.log('no tracking tag manager')
    }

    if(typeof googletag === 'undefined' || googletag === null) {
        console.log('no tracking googletag')
    } else {
        // googletag.pubads().refresh()
    }
}

// movie
const trackMovie = (eventAction, eventFn, eventOrigin, withPerformance = false) => {
    const extendEventFn = (args) => {
        const dateObj = withPerformance ? getMomentDateObj(args.timeUtc, trackingTimezone) : null
        
        track('movie', eventAction, eventOrigin, {
            movie_title: args.movieTitle,
            ... withPerformance && { 
                performance_date: dateObj.format('DD.MM.YYYY'),
                performance_time: dateObj.format('kk:mm')
            }
        })

        eventFn(args)
    }

    return extendEventFn
}

export const trackMovieInformationOpen  = (eventFn, eventOrigin) => trackMovie('click_movie_information_open', eventFn, eventOrigin)
export const trackMovieInformationClose = (eventFn, eventOrigin) => trackMovie('click_movie_information_close', eventFn, eventOrigin)

export const trackMovieDetailsOpen      = (eventFn, eventOrigin) => trackMovie('click_movie_details_open', eventFn, eventOrigin)
export const trackMovieDetailsClose     = (eventFn, eventOrigin) => trackMovie('click_movie_details_close', eventFn, eventOrigin)

export const trackMoviePerformanceOpen  = (eventFn, eventOrigin) => trackMovie('click_movie_performance_open', eventFn, eventOrigin, true)
export const trackMoviePerformanceClose = (eventFn, eventOrigin) => trackMovie('click_movie_performance_close', eventFn, eventOrigin, true)

// ui
export const trackUiOverviewChangeView = (eventFn, eventOrigin) => {
    const extendEventFn = (args) => {
        track('ui', 'click_program_change_view', eventOrigin, {program_view: args.view})
        eventFn(args)
    }

    return extendEventFn
}

export const trackUiOverviewFilter = (eventOrigin, filterObj) => track('ui', 'click_program_filter', eventOrigin, {program_filter: filterObj})

export const trackAdvertisementView = (eventOrigin, id, name) => track('advertisement', 'advertisement_in_view', eventOrigin, {
    id: id,
    name: name
})

export const trackAdvertisementClick = (eventOrigin, id, name, url) => track('advertisement', 'advertisement_click', eventOrigin, {
    id: id,
    name: name,
    url: url
})